import { Link } from "@/navigation.ts";
import { defaultLocale } from "@/config.ts";
import React, { useEffect, useState } from "react";
import { useCategory } from "@/context/CategoriesContext.tsx";
import { fetchProductData } from "@/lib/api/product";
import { getChannelLanguageMap } from "@/lib/api/channel";
import { Placeholder } from "@/components/Placeholder";
import { filterCateImg } from "@/components/Home2/Collection";
import { Skeleton } from "antd";

const CategoriesMenuTwo = ({ locale }: { locale: string }) => {
	const { categories } = useCategory();
	const [channel, setChannel] = useState<any>();
	const [productData, setProductData] = useState<any>();
	const [currentCate, setCurrentCate] = useState<any>("");
	const [currentCateName, setCurrentCateName] = useState<any>();
	const [showProList, setShowProList] = useState<any>(false);
	const [catesProductData, setCatesProductData] = useState<any>();
	const [currentCateNameChilds, setCurrentCateNameChilds] = useState<any>("");
	const [allProduct, setAllProduct] = useState<any>();

	// const productData = await fetchProductData({ locale, channel });
	useEffect(() => {
		getChannelLanguageMap().then((res) => {
			if (res[defaultLocale]) {
				setChannel(res[defaultLocale]);
			}
		});
	}, []);
	useEffect(() => {
		if (channel) {
			fetchProductData({ locale, channel }).then((res) => {
				if (res) {
					setAllProduct(res.products?.edges);
					const currentList = res.products?.edges?.filter((item) => {
						return item.node.category.name === currentCateName;
					});
					setProductData(currentList);
					console.log("接口拿到的数据", allProduct);
				}
			});
		}
	}, [channel, currentCateName]);
	useEffect(() => {
		// console.log("this is categories", categories);
		// console.log("this is productData", productData);
		// console.log("this is channel", channel);
	}, [channel, categories, productData]);
	const handleMouseEnter = (cate) => {
		setCurrentCateName(cate.name);
		setCurrentCate(cate);
		setCurrentCateNameChilds(cate.children.edges);
		// console.log("this is currentCate", currentCate);
		setShowProList(true);
	};
	useEffect(() => {
		setCurrentCate(categories?.edges[0].node);
		setCurrentCateName(categories?.edges[0].node.name);
		setCurrentCateNameChilds(categories?.edges[0].node.children.edges);

		// console.log("this is categories", categories);
	}, [channel]);
	return (
		<div>
			<div className=" invisible absolute left-0   w-screen origin-top   scale-y-0  transform overflow-scroll rounded-b-sm border-t border-t-gray-300  bg-gray-50   px-3 py-5 opacity-0 shadow transition-all duration-500 ease-in-out group-hover:visible  group-hover:scale-y-100 group-hover:opacity-100 ">
				<div className="container flex ">
					<ul className=" mr-10 mt-[30px] flex  w-[300px] flex-col gap-2 overflow-scroll">
						{categories?.edges.map((item) => {
							return (
								<li
									key={item.node.id}
									className={`relative px-6 py-2   ${
										currentCateName === item.node.name ? "bg-[#F5F5F5]" : ""
									}`}
								>
									<Link
										href={"/products/" + item.node.slug}
										className={`flex items-center  justify-between text-black `}
										onMouseEnter={() => handleMouseEnter(item.node)}
									>
										<div className="flex items-center gap-x-2  py-2  ">
											<div className="font-bold">
												{locale === defaultLocale
													? item.node.name
													: item.node.translation?.name || item.node.name}
											</div>
										</div>
									</Link>
									{/* {item.node.children.edges.length > 0 && (
										<div className="z-10   w-full transform overflow-hidden   rounded-b-sm   transition-all  duration-700 ">
											<ul className="  grid w-full grid-cols-1">
												{item.node.children?.edges.map((item) => {
													return (
														<li
															key={item.node.id}
															className="relative  inline-block    w-full p-1 transition-all  duration-700"
														>
															<Link
																href={"/products/" + item.node.slug}
																className="flex w-full items-center    text-black "
															>
																<div className="">{item.node.name}</div>
															</Link>
														</li>
													);
												})}
											</ul>
										</div>
									)} */}
								</li>
							);
						})}
					</ul>
					<div className={`${currentCate?.children?.edges.length > 0 ? "hidden" : ""} overflow-scroll`}>
						<div className="  flex items-center">
							<div className="text-[18px] font-bold text-main">{currentCateName}</div>
							<Link href={"/products/"} className=" ml-8  text-[10px] normal-case text-black">
								All Products →
							</Link>
						</div>
						<div className="  grid grid-cols-4 gap-[80px] max-2xl:gap-[40px] ">
							{productData&&productData
								? productData.slice(0, 4).map((item) => {
										return (
											<Link
												href={"/product/" + item.node?.slug}
												key={item.node.id}
												className="flex h-[250px] w-[200px] flex-col items-center justify-center gap-y-2 rounded-sm text-black  max-2xl:w-[150px] "
											>
												<div className="c-flex">
													<Placeholder
														src={filterCateImg(item.node?.metadata)[0]?.url || "/image/default-image.webp"}
														quality={60}
														imageHeight={500}
														imageWidth={500}
														fit="cover"
														className="mx-auto duration-200  ease-in-out hover:scale-110"
													/>
												</div>
												<p>{item.node.name}</p>
											</Link>
										);
									})
								: Array.from({ length: 4 }, (_, index) => index).map((item) => {
										return <Skeleton.Image key={item} active style={{ width: 200, height: 250 }} />;
									})}
						</div>
					</div>
					<div
						className={`${
							currentCate?.children?.edges.length > 0 ? "" : "hidden"
						} flex flex-col !overflow-scroll`}
					>
						{currentCateNameChilds?.length > 0 &&
							currentCateNameChilds.map((item, index) => {
								return (
									<div className="" key={index}>
										<div className=" mt-[30px] flex  items-center">
											<div className="text-[18px] font-bold text-main">{item.node.name}</div>
											<Link href={"/products/"} className=" ml-8  text-[10px] normal-case text-black">
												All Products →
											</Link>
										</div>
										<div className=" mt-[25px] grid grid-cols-4 gap-[80px] max-2xl:gap-[40px] ">
											{allProduct
												? allProduct
														.filter((item2) => {
															return item2.node.category.name == item.node.name;
														})
														.slice(0, 4)
														.map((item) => {
															return (
																<Link
																	href={"/product/" + item.node?.slug}
																	key={item.node.id}
																	className="flex h-[250px] w-[200px] flex-col items-center justify-center gap-y-2 rounded-sm text-black   max-2xl:w-[150px] "
																>
																	<div className="c-flex">
																		<Placeholder
																			src={
																				filterCateImg(item.node?.metadata)[0]?.url ||
																				"/image/default-image.webp"
																			}
																			quality={60}
																			imageHeight={500}
																			imageWidth={500}
																			fit="cover"
																			className="mx-auto duration-200  ease-in-out hover:scale-110"
																		/>
																	</div>
																	<p className="font-poppins text-[10px]">{item.node.name}</p>
																</Link>
															);
														})
												: Array.from({ length: 4 }, (_, index) => index).map((item) => {
														return <Skeleton.Image active key={item} style={{ width: 200, height: 250 }} />;
													})}
										</div>
									</div>
								);
							})}
						{/* <div className=" mt-[30px] flex items-center">
							<div className="text-[16px]">{currentCateName}</div>
							<Link href={"/products/"} className=" ml-8  text-[10px] normal-case text-black">
								All Products →
							</Link>
						</div>
						<div className=" mt-[45px] grid grid-cols-4 gap-[80px] max-2xl:gap-[40px] ">
							{productData
								? productData.slice(0, 4).map((item) => {
										return (
											<Link
												href={"/product/" + item.node?.slug}
												key={item.node.id}
												className="flex h-[250px] w-[200px] flex-col items-center justify-center gap-y-2 rounded-sm text-black max-2xl:h-[150px]  max-2xl:w-[150px] "
											>
												<div className="c-flex">
													<Placeholder
														src={filterCateImg(item.node?.metadata)[0]?.url || "/image/default-image.webp"}
														quality={60}
														imageHeight={500}
														imageWidth={500}
														fit="cover"
														className="mx-auto duration-200  ease-in-out hover:scale-110"
													/>
												</div>
												<p>{item.node.name}</p>
											</Link>
										);
									})
								: Array.from({ length: 4 }, (_, index) => index).map((item) => {
										return <Skeleton.Image active style={{ width: 200, height: 250 }} />;
									})}
						</div> */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CategoriesMenuTwo;
